const useBreadcrumbLinks = (breadcrumbOptions, subsection = []) => {
  const links = [
    {
      href: "#",
      contents: "Settings",
      disclosureLinks: breadcrumbOptions,
    },
    ...(Array.isArray(subsection) ? subsection : [subsection]),
  ];

  return links;
};

export default useBreadcrumbLinks;
